// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'expose-loader?jQuery!jquery' // eslint-disable-line
import 'expose-loader?$!jquery' // eslint-disable-line
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueTouch from 'vue-touch'
import Trend from 'vuetrend'
import trumbowyg from 'vue-trumbowyg'
import { ClientTable } from 'vue-tables-2'
import VueTextareaAutosize from 'vue-textarea-autosize'
import mavonEditor from 'mavon-editor'
import { VueMaskDirective } from 'v-mask'
import VeeValidate from 'vee-validate'
import VueFormWizard from 'vue-form-wizard'

import store from './store'
import router from './Routes'
import App from './App'

Vue.use(BootstrapVue)
Vue.use(VueTouch)
Vue.use(Trend)
Vue.use(trumbowyg)
Vue.use(ClientTable, {theme: 'bootstrap4'})
Vue.use(VueTextareaAutosize)
Vue.use(mavonEditor)
Vue.directive('mask', VueMaskDirective)
Vue.use(VeeValidate, {fieldsBagName: 'fieldsbag'})
Vue.use(VueFormWizard)

Vue.config.productionTip = false
Vue.config.devtools      = true

// Plugins

// plugin setup
// Vue.use(VueRouter)

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const fb = require('./firebaseConfig.js')

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import firebase from 'firebase'
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const {Messenger} = window

Messenger.options = {
  extraClasses: 'messenger-fixed messenger-on-bottom ',
  theme:        'air',
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import VueSelectImage from 'vue-select-image'

Vue.use(VueSelectImage)
// add stylesheet
require('vue-select-image/dist/vue-select-image.css')

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import VueLazyLoad from 'vue-lazyload'

Vue.use(VueLazyLoad)

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

fb.auth.onAuthStateChanged(user => {
  if (user)
  {
    store.commit('setCurrentUser', user)
    store.dispatch('fetchUserProfile')
  }
})

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Moment from 'moment'

Vue.filter('unixToDate', function (value) {
  if (!value) return ''
  return Moment.unix(value.seconds).format()
})

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function migrationUpdateMedias ()
{
  var promises = []
  debugger
  fb.mediasCollection.get().then(function (querySnapshot) {

    querySnapshot.forEach(function (doc) {

      var dt = doc.data().updatedOn
      dt.seconds++
      promises.push(fb.mediasCollection.doc(doc.id).update({
        updatedOn: dt
      }))

    })
    Promise.all(promises)
  })

}

// global library setup
// Object.defineProperty(Vue.prototype, '$Chartist', {
//   get ()
//   {
//     return this.$root.Chartist
//   }
// })

/* eslint-disable no-new */
const unsubscribe = fb.auth
  .onAuthStateChanged((firebaseUser) => {
    new Vue({
      el:     '#app',
      router,
      store,
      data:   {
        // Chartist: Chartist
      },
      render: h => h(App),
      created ()
      {

        if (firebaseUser)
        {

          store.dispatch('autoSignIn', firebaseUser)
        }
      }
    })
    unsubscribe()
  })
